export default __webpack_public_path__ + "static/media/blog4.1a6bfdfb.jpg";